import * as React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const ProgressBar = ({ value }) => {
  const getColor = (value) => {
    if (value < 30) return 'error';
    if (value <= 70) return 'warning';
    return 'success';
  };

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <LinearProgress 
        variant="determinate" 
        value={value} 
        color={getColor(value)}
        sx={{
          height: 26,
          borderRadius: 2,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 2,
          }
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 'medium',
            color: value > 70 ? 'white' : 'black',
            textShadow: value > 70 ? '0 0 2px rgba(0,0,0,0.5)' : 'none'
          }}
        >
          {`${value.toLocaleString()} %`}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProgressBar;
